import AddCadForm from '../components/AddCadForm';
import AppDetail from './detail';
import AppEditForm from './edit';
import AppParkingHistoryList from './parking_history_list';
import AppPurchaseHistoryList from './purchase_history_list';
import AppRegisterVehicleForm from './register_vehicle_form';
import AppRenewParkingForm from './renew_parking_form';
import SetAdmForm from '../components/SetAdmForm';
import AppStartParkingForm from './start_parking_form';

const Controls = {
  AddCadForm,
  AppDetail,
  AppEditForm,
  AppParkingHistoryList,
  AppPurchaseHistoryList,
  AppRegisterVehicleForm,
  AppRenewParkingForm,
  SetAdmForm,
  AppStartParkingForm
}

export default Controls;
